import { Button } from "antd";

export const camposFormulario = (tipoUsuario, roles) => {
    return {
        title: "Usuario",
        campos: [
            {
                name: "nombre",
                label: "Nombre de Usuario",
                type: "text"
            },
            {
                name: "tius_id",
                label: "Tipo de usuario",
                type: "select",
                opciones: tipoUsuario
            },
            {
                name: "role_id",
                label: "Rol",
                type: "select",
                opciones: roles
            },
            {
                name: "identificador",
                label: "Identificador Usuario",
                type: "number"
            },
        ]
    }
}

export const columns = (moveTab = null) => {

    return [
        {
            title: "Nombre",
            dataIndex: "nombre",
            width: "20%",
            render: (_, fila) => {
                return (<Button
                    type="link"
                    onClick={() => moveTab(fila)}
                >
                    {fila?.nombre}
                </Button>)
            }
        },
        {
            title: "Identificador",
            dataIndex: "identificador",
            width: "20%",
        },
        {
            title: "Correo",
            dataIndex: "correo",
            width: "20%",
        },
        {
            title: "Tipo Usuario",
            dataIndex: "tipoUsuario",
            width: "20%",
        },
        {
            title: "Rol",
            dataIndex: "rol",
            width: "20%",
        },
    ];
}
export const camposFormularioCrear = (tipoUsuario = [], roles = []) => {
    return {
        title: "Crear Usuario",
        campos: [
            {
                name: "usua_nombre",
                label: "Nombre de Usuario",
                type: "text",
                rules: [
                    {
                        max: 20,
                        message: "Máximo 20 caracteres",
                    },
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
                span: 12
            },
            {
                name: "usua_nombre_real",
                label: "Nombre real",
                type: "text",
                rules: [
                    {
                        max: 15,
                        message: "Máximo 15 caracteres",
                    },
                    {
                        required: false,
                        message: "Campo requerido",
                    }
                ],
                span: 12
            },
            {
                name: "usua_ig",
                label: "Instagram",
                type: "text",
                rules: [
                    {
                        max: 15,
                        message: "Máximo 15 caracteres",
                    },
                    {
                        required: false,
                        message: "Campo requerido",
                    }
                ],
                span: 12
            },
            {
                name: "usua_correo",
                label: "Correo",
                type: "text",
                rules: [
                    {
                        max: 50,
                        message: "Máximo 50 caracteres",
                    },
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
                span: 12
            },
            {
                name: "usua_password",
                label: "Contraseña",
                type: "password",
                rules: [
                    {
                        max: 25,
                        message: "Máximo 25 caracteres",
                    },
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
            },
            {
                name: "tius_id",
                label: "Tipo de usuario",
                type: "select",
                opciones: tipoUsuario,
                rules: [
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
                span: 12
            },
            {
                name: "role_id",
                label: "Rol",
                type: "select",
                opciones: roles,
                rules: [
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
                span: 12
            },
        ],
    }
}
